import { render, staticRenderFns } from "./PeopleSelect.vue?vue&type=template&id=3642ce06&lang=pug&"
import script from "./PeopleSelect.vue?vue&type=script&lang=js&"
export * from "./PeopleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports